"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNonEmptyStringOrUndefined = getNonEmptyStringOrUndefined;
const isNonEmptyString_1 = require("./isNonEmptyString");
function getNonEmptyStringOrUndefined(input) {
    return (0, isNonEmptyString_1.isNonEmptyString)(input) ? input : undefined;
}
//# sourceMappingURL=getNonEmptyStringOrUndefined.js.map